<template>
<div class="tab-inner-left">
  <div class="form-module">
    <h2>Main Title Text</h2>
    <p>This will be the first thing the customer will see. Make sure it's strong and engaging.</p>
    <input @input="update_data('campaignSlogan')" type="text"
           @focus="campaign_slogan__focused"
           @blur="campaign_slogan__blur"
           v-model="title" class="al-input" placeholder="Enter slogan here..."
           data-vv-name="Campaign Title"
           name="Campaign Title"
           ref="Campaign Title"
           v-validate="'required'"
    />
    <span class="text-danger text-sm" v-show="errors.has('Campaign Title')">{{ errors.first('Campaign Title') }}</span>
  </div>

  <div class="form-module">
    <h2>Sub Title Text</h2>
    <p>This award will be given to everyone who fills out the form without exception. It appears clearly in the form as a thick and burgundy color.</p>
    <input @input="update_data('campaignAward')"
           @focus="campaign_award__focused"
           @blur="campaign_award__blur" type="text" class="al-input"
           v-model="offer" placeholder="Enter slogan here..."
           data-vv-name="Offer"
           ref="Offer"
           v-validate="'required'"
    />
    <span class="text-danger text-sm" v-show="errors.has('Offer')">{{ errors.first('Offer') }}</span>
  </div>
   <div class="form-module">
    <h2>Award Name</h2>
    <p>Write a simple and plain name to be used both in award e-mails and in the system.</p>
    <input type="text" class="al-input"
           v-model="award_name"
           @focus="award_name__focused"
           @blur="award_name__blur"
           @input="update_data('awardName')"
           placeholder="Award name here..."
    />
  </div>
  <div class="form-module">
    <h2>Campaign Award Visual</h2>
    <p>This image could be something that will make the campaign award look more appealing.</p>
    <upload-image :required="this.campaign_image_id === ''" :img_id="(this.campaign_image_id === '') ? null : this.campaign_image_id" :code="'campaign-image'" :index="-1" :callback="campaignUploaded" />
  </div>
  <div class="form-module">
    <h2>Custom Link </h2>
    <p>Add your custom link</p>
    <div class="flex flex-grow-1">
      <vs-switch class="m-2 switch-button" v-model="is_custom_link"></vs-switch>
      <span class="p-2">{{ is_custom_link ? 'Disable' : 'Enable' }}</span>
    </div>
    <div class="flex flex-col w-full" v-if="is_custom_link">
      <input type="text" class="al-input"
             @input="update_data('customLink')"
             v-model="custom_link" />
      <h2>Button Title</h2>
      <p>You can edit this button under <strong>Customization</strong> tab</p>
      <input type="text" class="al-input"
             @input="update_data('customLink')"
             v-model="custom_link_button_title" />
             <h2>Button Sub Text</h2>
      <p>You can edit this text under <strong>Customization</strong> tab</p>
      <input type="text" class="al-input"
             @input="update_data('customLink')"
             v-model="custom_link_title"/>
    </div>
  </div>
  <div class="form-module">
    <h2>Submit Button Text</h2>
    <p>You can edit this button under <strong>Customization</strong> tab</p>
    <input type="text" class="al-input"
           @input="update_data('submitButton')"
           v-model="submit_button_text" />

    <h2>Submit Button Sub Text</h2>
    <p>You can edit this text under <strong>Customization</strong> tab</p>
    <input type="text" class="al-input"
           @input="update_data('submitButton')"
           v-model="submit_button_subtext"/>
  </div>
  <div class="form-module">
    <h2>Set Expiration Date</h2>
    <p>Choose how long after the reward code expires after it is earned.</p>
    <select class="al-select" v-model="expires">
      <option value="1 hour">Expires After - 1 Hour</option>
      <option value="2 hour">Expires After - 2 Hour</option>
      <option value="6 hour">Expires After - 6 Hour</option>
      <option value="12 hour">Expires After - 12 Hour</option>
      <option value="1 day">Expires After - 1 Day</option>
      <option value="1 week">Expires After - 1 Week</option>
      <option value="2 week">Expires After - 2 Week</option>
      <option value="3 week">Expires After - 3 Week</option>
      <option value="1 month">Expires After - 1 Month</option>
      <option value="2 month">Expires After - 2 Month</option>
      <option value="3 month">Expires After - 3 Month</option>
      <option value="6 month">Expires After - 6 Month</option>
      <option value="1 year">Expires After - 1 Year</option>
    </select>
  </div>
</div>
</template>

<script>
import UploadImage from '../../../../layouts/components/navbar/UploadImage'

export default {
  props: {
    update: {
      type: Function
    },
    dataVal: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data () {
    return {
      create: true,
      dataImg: require('@/assets/images/logo/logo.png'),
      uploadImg: null,
      name: '',
      custom_link_button_title: '',
      custom_link_title: '',
      custom_link: '',
      submit_button_text: '',
      submit_button_subtext: '',
      is_custom_link: false,
      expires: '',
      logo_id: '',
      title: '',
      award_name: '',
      offer: '',
      campaign_image_id: '',
      fieldnames: [
        {
          name: 'Name',
          type: 'text',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          type: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          type: 'email',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          type: 'date',
          value: false
        },
        {
          name: 'ZIP Code',
          code: 'address',
          type: 'text',
          value: false
        }
      ],
      fieldList: [],
      prizeList: [],
      prizeDefault: {
        name: '',
        image_id: ''
      },
      campaign_name_focused: false,
      campaign_slogan_focused: false,
      campaign_award_focused: false,
      award_name_focused: false
    }
  },
  components: {
    UploadImage
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  mounted () {
    this.set_data()
  },
  watch: {
    dataVal () {
      this.set_data()
    },
    expires () {
      this.update_data()
    },
    is_custom_link () {
      this.update_data('customLink')
    }
  },
  computed: {
    post_detail () {
      return this.$store.state.post_detail
    },
    custom_link_data () {
      return {
        link: this.custom_link,
        title: this.custom_link_title,
        button_title: this.custom_link_button_title,
        is_active: this.is_custom_link
      }
    },
    submit_data () {
      return {
        text: this.submit_button_text,
        subtext: this.submit_button_subtext
      }
    }
  },
  methods: {
    award_name__focused () {
      this.award_name_focused = true
      this.update_data('awardName')
    },
    campaign_slogan__focused () {
      this.campaign_slogan_focused = true
      this.update_data('campaignSlogan')
    },
    campaign_award__focused () {
      this.campaign_award_focused = true
      this.update_data('campaignAward')

    },
    award_name__blur () {
      this.award_name_focused = false
      this.update_data(null)
    },
    campaign_slogan__blur () {
      this.campaign_slogan_focused = false
      this.update_data(null)
    },
    campaign_award__blur () {
      this.update_data(null)
      this.campaign_award_focused = false
    },
    campaignUploaded (result) {
      console.log('campaign', result)
      this.campaign_image_id = result
      this.update_data('campaignAwardVisual')
    },
    set_data () {
      const { offer, title, award_name, campaign_image_id, expires, custom_link, submit_data } = JSON.parse(JSON.stringify(this.dataVal))
      this.offer = offer
      this.title = title
      this.award_name = award_name
      this.campaign_image_id = campaign_image_id
      this.expires = expires

      this.custom_link = custom_link.link
      this.custom_link_title = custom_link.title
      this.custom_link_button_title = custom_link.button_title
      this.is_custom_link = custom_link.is_active

      this.submit_button_text = submit_data.text
      this.submit_button_subtext = submit_data.subtext
      console.log('setting data', this.dataVal)
    },
    update_data (ref) {
      this.update(this.offer, this.title, this.award_name, this.campaign_image_id, this.expires, this.custom_link_data, this.submit_data)
      this.$store.commit('SET_EDITING_NOW', ref)
    }
  }
}
</script>

<style lang="scss">
</style>
